
import GuidPanel from "@/components/view/GuidPanel.vue";
import PasswordPanel from "@/components/view/PasswordPanel.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: 'HomeView',
  components: {
    PasswordPanel: PasswordPanel,
    GuidPanel: GuidPanel
  },
  data() {
    return {
      title: 'This is general page'
    }
  },
  mounted() {
    console.log('home')
  },
})
